/** A picture's or video's width in the page column (Small, Medium, Full). */
export const mediaWidthClasses = { small: "w-1/2", medium: "w-3/4", full: "w-full" } as const;
export type MediaSize = keyof typeof mediaWidthClasses;
/** Each size as a share of the column, in %. */
export const MEDIA_SIZE_PERCENT: Record<MediaSize, number> = { small: 50, medium: 75, full: 100 };
/** A picture's or video's box: a dragged width, else its size. */
export const mediaBox = (content: { size: MediaSize; width?: number }) =>
  content.width
    ? // Never so narrow on a phone that it's lost.
      { className: "", style: { width: `${content.width}%`, minWidth: "min(100%, 160px)" } }
    : { className: mediaWidthClasses[content.size], style: undefined };

/** A width set by dragging, or one of the sizes it settled on. */
export type MediaResizeChange = { size: MediaSize; width?: undefined } | { width: number };
const MIN_WIDTH = 20;
/** Within this many % of a size, a drag settles on it. */
const SNAP = 3;
/** Where a drag lands: a size when it's close to one, else a whole %. */
export function resizeTarget(percent: number): MediaResizeChange {
  const clamped = Math.min(100, Math.max(MIN_WIDTH, percent));
  const near = (Object.keys(MEDIA_SIZE_PERCENT) as MediaSize[]).find(
    (size) => Math.abs(MEDIA_SIZE_PERCENT[size] - clamped) <= SNAP,
  );
  return near ? { size: near } : { width: Math.round(clamped) };
}
